export class VaultSnapshotCount {
    'vaultId';
    'count';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VaultSnapshotCount.attributeTypeMap;
    }
    constructor() {
    }
}
